if (!customElements.get('comparison-table-mobile')) {
  customElements.define(
    'comparison-table-mobile',
    class ComparisonTableMobile extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderNode = this.querySelector('.swiper');
        if (!this.sliderNode) return;

        this.initSlider();
      }

      initSlider() {
        const swiperOptions = {
          slidesPerView: 'auto',
          centeredSlides: true,
          centeredSlidesBounds: true,
          spaceBetween: 16,
          loop: false
        };

        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.carousel = new window.FoxTheme.Carousel(this.sliderNode, swiperOptions);
          this.carousel.init();
          this.swiper = this.carousel.slider;
        } else if (window.Swiper) {
          this.swiper = new window.Swiper(this.sliderNode, swiperOptions);
        } else {
          console.warn('Swiper not found for Comparison Table');
          return;
        }

        // Handle normal scrolling
        this.swiper.on('slideChange', () => {
          this.updateSyncElements(this.swiper.activeIndex);
        });

        // Track manual taps on slides (Swiper handles mobile taps as 'click')
        this.swiper.on('click', (swiper, event) => {
          if (typeof swiper.clickedIndex !== 'undefined') {
            // Prevent anchor links inside the slide from firing and navigating away
            const clickedLink = event.target.closest('a');
            if (clickedLink && !clickedLink.classList.contains('singleton-cta') && !clickedLink.classList.contains('comparison-table__cta-mobile')) {
               event.preventDefault();
            }
            
            this.updateSyncElements(swiper.clickedIndex);
            if (swiper.slideTo) {
              swiper.slideTo(swiper.clickedIndex);
            }
          }
        });

        // Initialize state
        this.updateSyncElements(0);

        // Store slide data for syncing links
        this.slideLinks = Array.from(this.querySelectorAll('.comparison-table__mobile-slide')).map(el => {
          return el.dataset.url;
        });
      }

      updateSyncElements(index) {
        // Update accordion content
        const values = this.querySelectorAll('.comparison-table__dynamic-value');
        values.forEach((val) => {
          val.style.display = parseInt(val.dataset.index) === index ? 'block' : 'none';
        });

        // Update active class for UI
        const allSlides = this.querySelectorAll('.comparison-table__mobile-slide');
        allSlides.forEach(s => s.classList.remove('is-active'));
        
        const activeSlide = this.querySelector(`.comparison-table__mobile-slide[data-index="${index}"]`);
        if (activeSlide) {
          activeSlide.classList.add('is-active');

          // Update singleton button link
          const singletonBtn = this.querySelector('.singleton-cta');
          const productUrl = activeSlide.dataset.url;
          if (singletonBtn && productUrl) {
            singletonBtn.setAttribute('href', productUrl);
          }
        }
      }
    }
  );
}

// Format Klaviyo widget rating label inside comparison table
document.addEventListener('DOMContentLoaded', () => {
  const comparisonTable = document.querySelector('.comparison-table');
  if (!comparisonTable) return;

  const observer = new MutationObserver((mutations) => {
    let hasChanges = false;
    
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        hasChanges = true;
      }
    });

    if (hasChanges) {
      const labels = comparisonTable.querySelectorAll('.klaviyo-star-rating-widget .kl_reviews__star_rating_widget__label');
      labels.forEach((label) => {
        if (!label.dataset.formatted) {
          const text = label.innerText || label.textContent;
          if (text) {
            // Check if it looks like "381 REVIEWS"
            const match = text.match(/\d+/);
            if (match) {
              label.innerText = `(${match[0]})`;
              label.dataset.formatted = "true";
            }
          }
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});